import { useEffect } from 'react';

import { UseFormSetValue } from 'react-hook-form';

import { DepartmentsService } from '../../../components/services/DepartmentsService';
import { EmployeesService } from '../../../components/services/EmployeesService';
import { Task } from '../../../types/interfaces';

interface UseTaskPrefetchProps {
  isNewTask: boolean;
  departmentId: string | null;
  employeeId: string | null;
  setValue: UseFormSetValue<Task>;
}

export function useTaskPrefetch({
  isNewTask,
  departmentId,
  employeeId,
  setValue
}: UseTaskPrefetchProps) {
  
  useEffect(() => {
    const prefetchData = async () => {
      if (!isNewTask) return;

      const promises = [];

      if (departmentId) {
        promises.push(
          DepartmentsService.getDepartmentById(Number(departmentId))
            .then(result => ({
              type: 'department' as const,
              data: result.data,
              id: departmentId
            }))
            .catch(error => {
              console.error('Ошибка при получении участка:', error);
              return null;
            })
        );
      }

      if (employeeId) {
        promises.push(
          EmployeesService.getEmployeeById(Number(employeeId))
            .then(result => ({
              type: 'employee' as const,
              data: result.data,
              id: employeeId
            }))
            .catch(error => {
              console.error('Ошибка при получении сотрудника:', error);
              return null;
            })
        );
      }

      const results = await Promise.all(promises);
      
      results.forEach(result => {
        if (!result) return;
        
        if (result.type === 'department' && result.data) {
          setValue(
            'department',
            {
              key: result.id,
              label: result.data.name
            },
            { shouldDirty: true, shouldValidate: true }
          );
        }
        
        if (result.type === 'employee' && result.data) {
          setValue(
            'employees',
            [
              {
                id: Number(result.id),
                fullName: result.data.fullName,
                personnelNumber: result.data.personnelNumber || ''
              }
            ],
            { shouldDirty: true, shouldValidate: true }
          );
        }
      });
    };

    prefetchData();
  }, [isNewTask, departmentId, employeeId, setValue]);
}
